import { render } from "./mru.vue?vue&type=template&id=2342c770&scoped=true&ts=true"
import script from "./mru.vue?vue&type=script&lang=ts"
export * from "./mru.vue?vue&type=script&lang=ts"

import "./mru.vue?vue&type=style&index=0&id=2342c770&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2342c770"]])

export default __exports__